import { SpendAreaStage, SpendAreaStatus } from '@sib/api';
import { ProjectStatus } from '@spendbrain/types/project';

export const spendCategoryToStageMap: Record<SpendAreaStage, ProjectStatus> = {
  [SpendAreaStage.MONITORING_SAVINGS]: ProjectStatus.MonitoringSavings,
  [SpendAreaStage.SAVINGS_REALIZED]: ProjectStatus.SavingsRealized,
  [SpendAreaStage.SAVINGS_ESTIMATED]: ProjectStatus.SavingsEstimated,
  [SpendAreaStage.MOBILIZATION]: ProjectStatus.Mobilization,
  [SpendAreaStage.NEGOTIATIONS]: ProjectStatus.Negotiations,
};

export const stageToSpendCategoryMap: Record<
  | ProjectStatus.MonitoringSavings
  | ProjectStatus.Mobilization
  | ProjectStatus.Negotiations
  | ProjectStatus.SavingsEstimated
  | ProjectStatus.SavingsRealized,
  SpendAreaStage
> = {
  [ProjectStatus.Mobilization]: SpendAreaStage.MOBILIZATION,
  [ProjectStatus.SavingsEstimated]: SpendAreaStage.SAVINGS_ESTIMATED,
  [ProjectStatus.Negotiations]: SpendAreaStage.NEGOTIATIONS,
  [ProjectStatus.SavingsRealized]: SpendAreaStage.SAVINGS_REALIZED,
  [ProjectStatus.MonitoringSavings]: SpendAreaStage.MONITORING_SAVINGS,
};

export const stageColors: Partial<Record<ProjectStatus, string>> = {
  [ProjectStatus.Mobilization]: '#2372F0',
  [ProjectStatus.SavingsEstimated]: '#E02D75',
  [ProjectStatus.Negotiations]: '#FFC130',
  [ProjectStatus.SavingsRealized]: '#18B030',
  [ProjectStatus.MonitoringSavings]: '#9747FF',
};

export const intermediateStages = [
  ProjectStatus.Mobilization,
  ProjectStatus.SavingsEstimated,
  ProjectStatus.Negotiations,
  ProjectStatus.SavingsRealized,
];

export const statusOrder: SpendAreaStatus[] = [
  SpendAreaStatus.COMPLETED,
  SpendAreaStatus.IN_PROGRESS,
  SpendAreaStatus.REQUESTED,
];

export const projectStatusColorsOrder = [
  ProjectStatus.Mobilization,
  ProjectStatus.SavingsEstimated,
  ProjectStatus.Negotiations,
  ProjectStatus.SavingsRealized,
  ProjectStatus.MonitoringSavings,
];
